import React, { SyntheticEvent, useRef, useEffect, useState } from "react";
import styles from "./horizontal-scroll.module.css";

export const HorizontalScroll: React.FC<{
  scroll: number;
  svgWidth: number;
  taskListWidth: number;
  rootRef: React.RefObject<HTMLDivElement>;
  rtl: boolean;
  onScroll: (event: SyntheticEvent<HTMLDivElement>) => void;
  scrollElRef?: React.MutableRefObject<HTMLDivElement | null>;
}> = ({ scroll: _scroll, svgWidth, taskListWidth, rtl, onScroll, rootRef, scrollElRef }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState<number>(0);

  // Expose this scroll container to the parent.
  useEffect(() => {
    if (scrollElRef) {
      scrollElRef.current = scrollRef.current;
    }
  });




  // Dynamically update width
  useEffect(() => {
    const updateWidth = () => {
      if (rootRef.current) {
        setWidth(rootRef.current.clientWidth - taskListWidth);
      }
    };

    updateWidth(); // initial
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, [rootRef, taskListWidth]);

  return (
    <div
      dir="ltr"
      style={{
        width,
        margin: rtl
          ? `0px ${taskListWidth}px 0px 0px`
          : `0px 0px 0px ${taskListWidth}px`,
      }}
      className={`${styles.scrollWrapper} absolute bottom-0 left-0 z-10`}
      onScroll={onScroll}
      ref={scrollRef}
    >
      <div style={{ width: svgWidth }} className={styles.scroll} />
    </div>
  );
};
